export class CommandConnectorQueueInsRequest {
    user: string;
    s_ins: number;
    panel: string;
    command: string;
    subcommand: string;
    exec_schedule: number;
    parameters: string;
    app_name = 'SIC';

    constructor(user: string, s_ins: number, panel: string, command: string, subcommand: string,
        exec_schedule: number, parameters: string){
        this.user = user;
        this.s_ins = s_ins;
        this.panel = panel;
        this.command = command;
        this.subcommand = subcommand;
        this.exec_schedule = exec_schedule;
        this.parameters = parameters;
    }
}